import {
  CLOSE_BUTTON,
  CONTENT_CONTAINER,
  VIDEO_PLAYER_CONTAINER,
  VIDEO_PLAYER_MODAL_CONTAINER,
  VIDEO_PLAYER_CONTENT_TO_HIDE
} from '../constants';
import $ from 'jquery';

class Abstract {
  constructor(container, {config}) {
    this.priority   = 0;
    this.final      = false;
    this.config     = config;
    this.container$ = $(VIDEO_PLAYER_CONTAINER).find(container).length ?
      $(VIDEO_PLAYER_CONTAINER).find(container) :
      $(container).eq(0);
  }

  isViewed() {
    return (this.config.viewed === 'true');
  }

  isMeterExceeded() {
    return this.config.meterExceeded && this.config.meterExceeded.length > 0;
  }

  isExtra() {
    return (this.config.isExtra === 'true');
  }

  concurrentSessionLimit() {
    return `${this.config.concurrentSessionLimit}`.trim();
  }

  replaceContent(removeContent) {
    if ($(VIDEO_PLAYER_MODAL_CONTAINER, VIDEO_PLAYER_CONTAINER).length) {
      if (removeContent) {
        $(VIDEO_PLAYER_CONTENT_TO_HIDE, VIDEO_PLAYER_CONTAINER).remove();
      }
      var pwContainer$ = $('<div class="wrapper"></div>');
      $(VIDEO_PLAYER_MODAL_CONTAINER, VIDEO_PLAYER_CONTAINER).append(pwContainer$);
      pwContainer$.append(this.container$);
    } else {
      if (removeContent) {
        $(CONTENT_CONTAINER).html(this.container$);
      } else {
        $(CONTENT_CONTAINER).append(this.container$);
      }
    }
  }

  show() {
    $(CLOSE_BUTTON, this.container$).on('click', (event) => {
      event.preventDefault();
      this.container$.hide();
    });
    this.replaceContent();
    this.container$.show();
  }

  static canNotViewContent() {
    $("div[data-voc-arrows-display]").remove();
    $(".wrapper.voc-story").css({"-webkit-user-select": "none", "-moz-user-select": "none", "-ms-user-select": "none", "user-select": "none"});
    $("body").addClass('no-scroll');
  };
}

export default Abstract;



// WEBPACK FOOTER //
// ./src/alerts/abstract.js